// src/contexts/LocaleContext.js
import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useMemo,
} from "react";
import { getHeaderFooterData } from "../api/apiService";
import { normalizeHeaderMenuItems } from "../utils/strapiFlatten";

const LocaleContext = createContext();

export const useLocale = () => useContext(LocaleContext);

export const LocaleProvider = ({ children }) => {
  const [locale, setLocale] = useState(localStorage.getItem("locale") || "en");
  const [headerData, setHeaderData] = useState({
    menuItems: [],
    onlineShopText: "",
    onlineShopTextUrl: "",
    logoData: null,
  });
  const [footerText, setFooterText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const changeLocale = (newLocale) => {
    if (newLocale !== locale) {
      setLocale(newLocale);
    }
  };

  const value = useMemo(
    () => ({
      locale,
      changeLocale,
      headerData,
      footerText,
      isLoadingSharedData: isLoading,
      sharedDataError: error,
    }),
    [locale, changeLocale, headerData, footerText, isLoading, error]
  );

  useEffect(() => {
    localStorage.setItem("locale", locale);

    const fetchSharedData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const data = await getHeaderFooterData(locale);
        console.log("Header Footer Data:", data); // Debug log
        if (data) {
          setHeaderData({
            menuItems: normalizeHeaderMenuItems(data.header_menu_items),
            // onlineShopText: data.shopping_cart || "",
            // onlineShopTextUrl: data.shopping_cart_url || "",
            logoData: data.logo || null,
          });
          setFooterText(data.copyright || "");
        } else {
          setError("No shared data received for locale: " + locale);
        }
      } catch (err) {
        console.error(`Error fetching shared data for locale ${locale}:`, err);
        setError(err.message || "Failed to load shared data.");
        setHeaderData({
          menuItems: [],
          onlineShopText: "",
          onlineShopTextUrl: "",
          logoData: null,
        });
        setFooterText("");
      } finally {
        setIsLoading(false);
      }
    };

    fetchSharedData();
  }, [locale]);

  return (
    <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
  );
};
